// extracted by mini-css-extract-plugin
export default {"wrapper":"OnePageCard_wrapper__KcIAe","upperCard":"OnePageCard_upperCard__lmyeO","iconStyles":"OnePageCard_iconStyles__YDmFf","backCard":"OnePageCard_backCard__E3nc5"};